export default __webpack_public_path__ + "static/logos-tiles-lam-c18a94e3dcf5e5ea76d52e647d3828ad.svg";